import { useEffect } from "react";

export function useBodyScrollLock({
  enabled = true,
}: { enabled?: boolean } = {}) {
  function disableScrollLock() {
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("scrollbar-gutter");
    document.documentElement.style.removeProperty("scrollbar-gutter");
  }

  function enableScrollLock() {
    document.body.style.overflow = "hidden";
    // Prevent content jumping due to scrollbar disappearing
    document.body.style.scrollbarGutter = "stable";
    document.documentElement.style.scrollbarGutter = "stable";
  }

  useEffect(() => {
    if (enabled) {
      enableScrollLock();
    } else {
      disableScrollLock();
    }

    return () => {
      disableScrollLock();
    };
  }, [enabled]);
}
